import { Link } from "react-router-dom";
import { site, siteValues } from "@/mocks/site";

export default function BrandCta() {
  return (
    <section className="bg-secondary-950 py-14 text-secondary-100 md:py-20">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="text-xs font-medium tracking-widest text-accent-400">ABOUT · 关于我们</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            {site.name}，把线索串成看得懂的经过
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-secondary-200/90">{site.mission}</p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-secondary-700 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              投稿一条线索
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-7">
          {siteValues.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-secondary-800 bg-secondary-900/60 p-5 md:p-6"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-accent-300">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-background-50">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-secondary-200/80">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}